import { ClasseProfit } from './classe.profit';


export class TypeAdresseTEMPOST {

	public ville: string;
	public tvaIntracommunautaire: string;
	public adr4: string;
	public adr3: string;
	public classeProfit: ClasseProfit;
	public siret: string;
	public cp: string;
	public adr2: string;
	public adr1: string;
	public denomination: string;
	public pays: string;

	constructor() {
		this.classeProfit = new ClasseProfit();
		this.ville = '';
		this.tvaIntracommunautaire = '';
		this.adr4 = '';
		this.adr3 = '';
		this.siret = '';
		this.cp = '';
		this.adr2 = '';
		this.adr1 = '';
		this.denomination = '';
		this.pays = '';
	}
}
